import { defineStore } from "pinia";
import { USER_SETTING_OPTIONS } from "../../../Constants/menus";
import Utilities from "../../../Helpers/utilities";
import { useUserStore } from "../../../Stores/User";
import axios from "axios";

const SAVE_CANCELED = "cancelled";
const SAVE_SUCCESS = "success";
const SAVE_HOLD = "hold";
const WORKDAY_TAB = "workday";

export const useSettings = defineStore("SettingsStore", {
    state: () => ({
        default_title: "Settings",
        options: USER_SETTING_OPTIONS,
        tab: USER_SETTING_OPTIONS.profile.name,
        validations: null,
        profiles: [],
        organizations: [],
        skip_toggle_save: true,
        toggle_save: false,
        toggle_save_state: SAVE_HOLD,
        bulk_save: [],
        documentDetails: {
            open: false,
            conv_id: undefined,
        },
        hasCancelClicked: false,
        user: null,
        profile: null,
    }),

    getters: {
        has_validation_errors: (state) => state.validations?.errors.length > 0,
        identities: (state) => [...state.profiles, ...state.organizations],
        save_state: (state) => {
            return {
                hold: state.toggle_save_state === SAVE_HOLD,
                success: state.toggle_save_state === SAVE_SUCCESS,
                cancelled: state.toggle_save_state === SAVE_CANCELED,
            };
        },
        is_workday_tab_opened: (state) => state.tab === WORKDAY_TAB,
    },

    actions: {
        setHasCancelClicked(val = false) {
            this.hasCancelClicked = val;
        },
        bulkSaveActions(references) {
            this.bulk_save.push(references);
        },
        bulkSave() {
            // TODOs
            // Implement axios all for multiple axios requests
            // Partial code
            axios.all(this.bulkSaveActions).then((responses) => {
                console.log("responses :>> ", responses);
            });
        },
        setValidations(data) {
            this.validations = data;
        },
        validate() {
            return this.validations?.validate();
        },
        resetValidations() {
            this.validations?.resetValidation();
        },
        addProfile(data) {
            this.profiles.push(data);
        },
        toggleSave(value = null) {
            if (value === null) return (this.toggle_save = !this.toggle_save);

            this.toggle_save_state = !value ? SAVE_CANCELED : SAVE_HOLD;
            this.toggle_save = value;
        },
        toggleSaveState(value) {
            this.toggle_save_state = !value ? SAVE_CANCELED : SAVE_SUCCESS;
        },
        switchSettingTab(tabName) {
            this.tab = tabName;
        },
        toggleDocument(show = false, convId = undefined) {
            this.documentDetails = {
                open: show,
                conv_id: show ? convId : undefined,
            };
        },

        confirmCallback() {
            this.snackbar();
            this.toggle_save = false;

            Object.keys(useUserStore().profile).forEach((key) => {
                useUserStore().profile[key] = this.profile[key];
            });
            useUserStore().profile.country_id = this.profile.country;
            useUserStore().updatePartialProfile();
        },

        cancelCallback() {
            this.toggleSave(false);
            this.setHasCancelClicked(true);
            setTimeout(() => {
                this.setHasCancelClicked(false);
            });
        },

        snackbar(
            message = "You have successfully added a profile!",
            color = "success",
        ) {
            const { setSnackbar, toggleSnackBarOn, toggleSnackBarOff } =
                Utilities();
            toggleSnackBarOff();

            setSnackbar({
                message: message,
                visible: false,
                timeout: 3000,
                color: color,
                location: "bottom right",
            });

            toggleSnackBarOn();
        },
    },
});
